<script>
  import { getContext } from "svelte";

  export let territories = [];

  const t = getContext("STRINGS");

  const defaultVisibleCount = 5;
  let visibleCount = defaultVisibleCount;
  const placeholder_src =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0IDMiPjxkZWZzLz48cGF0aCBmaWxsPSIjQkZCRkJGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDBoNHYzSDB6Ii8+PC9zdmc+Cg==";

  $: visibleTerritories = territories.slice(0, visibleCount);
</script>

<style>
  .gray-back {
    background: #eee;
  }
  .visibility-button {
    padding-left: 0;
    padding-right: 0;
    text-align: left;
    font-size: 11px;
  }
</style>

<div class="tc-geo-restrictions">
  {#each visibleTerritories as { alpha2, name, image_src } (alpha2)}
    <div class="tc-geo-restrictions--item">
      <div class="tc-geo-restrictions--item-flag">
        <img
          class="tc-icon--flag gray-back"
          alt={`Flag of: ${alpha2}`}
          title={alpha2}
          src={image_src}
          width="20"
          height="15"
          loading="lazy" />
      </div>
      <div class="tc-geo-restrictions--item-name">{name}</div>
    </div>
  {/each}
  {#if territories.length > visibleTerritories.length}
    <button
      type="button"
      on:click|once={() => (visibleCount = territories.length)}
      class="tc-button __size-toolbar __color-link visibility-button">
      {t('show')}
    </button>
  {:else if territories.length > defaultVisibleCount}
    <button
      type="button"
      on:click|once={() => (visibleCount = defaultVisibleCount)}
      class="tc-button __size-toolbar __color-link visibility-button">
      {t('hide')}
    </button>
  {/if}
</div>
